<template>
  <div class="home-page">
    <div class="news w" v-if="deviceType == 'pc'">
      <div class="head"></div>

      <div
        class="dSwipe"
        @mouseenter="stopAutoPlay"
        @mouseleave="startAutoPlay"
      >
        <div
          ref="mySwiper"
          class="swiper-container"
          :id="'swiper' + currentIndex"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in datalist"
              :key="index"
            >
              <div
                class="swiper-div"
                @click="clicklist(item)"
                style="cursor: pointer"
              >
                <div class="swiper-a">
                  <div class="pull-left date">
                    <h1 class="days">
                      {{ item.createTime.split('-')[1] }}
                    </h1>
                    <div class="year-month">
                      {{ item.createTime.split('-')[0] }}
                    </div>
                  </div>
                  <div class="article-right">
                    <div class="title">
                      {{ item.title }}
                    </div>
                    <div class="desc">
                      {{ item.description }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more clearfix">
        <div @click="clickxin">更多新闻</div>
      </div>
    </div>
    <div v-else>
      <div class="news">
        <div class="head">
          <img src="../../../assets//images/home/platform-6.png" alt="" />
        </div>
        <div class="news-box">
          <div class="news-region" @click="clicklist(datalist[0])">
            <div class="news-img">
              <img :src="datalist[0] ? datalist[0].coverImage : ''" alt="" />
            </div>
            <div class="news-content">
              <p class="p1">{{ datalist[0].title }}</p>
              <p class="p2 p3">
                {{ datalist[0].description }}
              </p>
              <p class="p2">{{ datalist[0].createTime }}</p>
            </div>
          </div>
          <div class="news-region" @click="clicklist(datalist[1])">
            <div class="news-img">
              <img :src="datalist[1] ? datalist[1].coverImage : ''" alt="" />
            </div>
            <div class="news-content">
              <p class="p1">{{ datalist[0].title }}</p>
              <p class="p2 p3">
                {{ datalist[0].description }}
              </p>
              <p class="p2">{{ datalist[0].createTime }}</p>
            </div>
          </div>
          <el-divider
            ><span class="divider-span" @click="clickxin"
              >更多新闻 >></span
            ></el-divider
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
import(
  `@/assets/css/${
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
      ? 'mobile'
      : 'pc'
  }/home.scss`
)
export default {
  components: {},
  data() {
    return {
      datalist: [],
      slideList: [],
      currentIndex: 1,
      currentSwiper: null,
      options: {
        loop: false,
        autoHeight: true,
        observeParents: true,
        observer: true,
        autoplay: {
          delay: 3000,
        },
        slidesPerView: 3,
      },
    }
  },
  watch: {
    slideList: {
      deep: true,
      handler(nv, ov) {
        this.updateSwiper()
      },
    },
  },
  computed: {
    deviceType() {
      return this.$store.state.app.deviceType
    },
  },
  mounted() {
    this.getArticlePage()
  },
  destroyed() {
    this.destroySwiper()
  },
  methods: {
    clickxin() {
      this.$router.push(`/news`)
    },
    clicklist(val) {
      this.$router.push(`/news/detail?id=${val.id}`)
    },
    getArticlePage() {
      const params = {
        categoryId: '5',
      }
      this.$api.home.getArticlePage(params).then((res) => {
        if (res.code === 200) {
          if (res.rows.length > 6) {
            this.datalist = res.rows.slice(0, 6)
          }
          this.initSwiper()
        }
      })
    },
    //鼠标移入暂停自动播放
    stopAutoPlay() {
      this.currentSwiper.autoplay.stop()
    },
    //鼠标移出开始自动播放
    startAutoPlay() {
      this.currentSwiper.autoplay.start()
    },
    //初始化swiper
    initSwiper() {
      this.currentSwiper = new Swiper(
        '#swiper' + this.currentIndex,
        this.options
      )
      console.log(this.currentSwiper, 'this.aaaa')
    },
    //销毁swiper
    destroySwiper() {
      try {
        this.currentSwiper.destroy(true, false)
      } catch (e) {
        console.log('删除轮播')
      }
    },
    //更新swiper
    updateSwiper() {
      this.destroySwiper()
      this.$nextTick(() => {
        this.initSwiper()
      })
    },
  },
}
</script>